import React, { Component } from "react";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'

//admin sidebar
import AdminSidebar from "./adminSidebar";

//partner sidebar
import PartnerSidebar from "./partnerSidebar";
import SioAndPressSidebar from "./sioAndpressSidebar";
import PrivateScreeningSidebar from './privateScreeningSidebar';


//satellite sidebar
import SatelliteSideBar from './satelliteSideBar'

const mapStateToProps = state => ({
    getLoginRole : state.getLoginRole,
    getBackToAdminPreviousPath:state.getBackToAdminPreviousPath
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Sidebar extends Component {
    constructor(props) {
        super()
        this.state={

        }
    }

    refresh=()=>{
        this.setState({});
        this.forceUpdate();
    }

    render() {
        const {getLoginRole} = this.props
        const user = getLoginRole &&  getLoginRole.user && getLoginRole.user.role;
        return (
            <>
                {user === "admin" ?
                    <AdminSidebar router={window.location} getBackToAdminPreviousPath={this.props.getBackToAdminPreviousPath}/>
                :
                user === "partner" ?
                    <PartnerSidebar router={window.location}/>
                :
                user === "satellite" ?
                    <SatelliteSideBar router={window.location}/>
                :
                user === "sio" || user === "press" || user === "sundanceCircle" || user === "sundanceGuest" || user === "general" || user === "artist"?
                    <SioAndPressSidebar router={window.location}/>
                :
                user === 'privateScreeningPartner' ? 
                    <PrivateScreeningSidebar router={window.location} refresh={this.refresh}/>
                : ''
                }
            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
